// Copyright (c) 2016 Deere & Company

import advancedClaimSummary from './advanced-claim-summary';
import claimHistory from './claim-history';
import claimsInProgress from '../claims-in-progress';
import creditMemo from './credit-memo';
import emissionsPartSearch from './emissions-part-search';
import {hasAccess} from '../../../shared/services/security';
import {hasPermission} from '../../../shared/services/privacy';
import laborRateHistory from './labor-rate-history';
import laborStats from './labor-stats';
import partsCoverageSearch from './parts-coverage-search';

export default state => {

    const reports = {
        childRoutes: [
            advancedClaimSummary,
            claimHistory,
            claimsInProgress
        ]
    };

    if (hasAccess(state.user.security, 'CLAIM', 'CLM_CREDIT_MEMO')) {

        reports.childRoutes.push(creditMemo);

    }

    reports.childRoutes.push(laborRateHistory);
    reports.childRoutes.push(emissionsPartSearch);
    reports.childRoutes.push(partsCoverageSearch);

    if (hasPermission(state.user.details.privacy, 'laborStatsNotAllowed')) {

        reports.childRoutes.push(laborStats);

    }

    return reports;

};



// WEBPACK FOOTER //
// ./src/routes/claims/reports/index.js